import { type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { env } from '@/lib/env'

interface AuthGuardProps {
  children: ReactNode
}

const isDevBypass = env.VITE_APP_ENV === 'development' && env.VITE_DEV_BYPASS_AUTH

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isDevBypass) {
    return <>{children}</>
  }

  if (isLoading) {
    return null
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />
  }

  return <>{children}</>
}
